module.exports = __webpack_public_path__ + "img/login.41df406d.svg";